import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_CLASSE_RESIDUOS } from 'store/modules/api/classeResiduos.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_CLASSE_RESIDUOS.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_CLASSE_RESIDUOS)

export default combineReducers({
  lista,
  isCarregandoLista,
})
